import * as actionTypes from '../action-types';
import { NotificationType } from '../../notification.types';
import { NotificationsActions } from '../actions';

type Reducer = { [notificationId: number]: boolean };

const defaultState: Reducer = {};

export function notifReadStatusMapReducer(
  state: Reducer = defaultState,
  action: NotificationsActions,
) {
  switch (action.type) {
    case actionTypes.SET_NOTIFICATIONS: {
      const { notifications } = action.payload;
      return notifications.reduce(
        (
          acc: { [notifId: number]: boolean },
          notification: NotificationType,
        ) => {
          acc[notification.id] = notification.alreadyRead;
          return acc;
        },
        {},
      );
    }
    case actionTypes.MARK_NOTIFICATION_AS_READ: {
      const { notificationId } = action.payload;
      return { ...state, [notificationId]: true };
    }
    case actionTypes.MARK_NOTIFICATIONS_AS_READ: {
      const { notificationsList } = action.payload;
      const newState = { ...state };
      notificationsList.forEach(notificationId => {
        newState[notificationId] = true;
      });
      return newState;
    }
    default: {
      return state;
    }
  }
}
